module.exports = __webpack_public_path__ + "static/media/Test33.077f6e62.bmp";